import { Box, Text, alpha, styled } from '@ltvco/refresh-lib/theme';

export const BannerRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',
  borderRadius: '12px',
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  margin: theme.spacing(3, 0),
}));

export const BannerHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2.5),
  padding: theme.spacing(2.75, 3),
}));

export const BannerIntro = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2.25),
}));

export const LogoCircle = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 52,
  height: 52,
  borderRadius: '100px',
  backgroundColor: theme.palette.common.white,
}));

export const BannerTitle = styled(Text)({ fontSize: 19, fontWeight: 700 });

export const BannerText = styled(Text)(({ theme }) => ({
  fontSize: 14,
  marginTop: theme.spacing(0.25),
}));

export const BannerMock = styled(Box)(({ theme }) => ({
  margin: theme.spacing(0, 2.5, 2.5),
  [theme.breakpoints.down('sm')]: { display: 'none' },
}));
